export default __webpack_public_path__ + "/dist/images/travel-icon.svg";